import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { initI18n } from '../../../../core/src/utils';
initI18n('FareLock');
const WarningDescription = () => {
    const { t } = useTranslation('FareLock');
    return (React.createElement("span", { dangerouslySetInnerHTML: {
            __html: t('Attention! Payment <strong>only with a plastic card</strong> (not SberPay)!')
        } }));
};
export default WarningDescription;
